<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// App component - router-view handles all routing
</script>
